/*
 * @Author: wjc
 * @Date: 2023-12-07 11:46:49
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-09 15:04:30
 * @Description:
 */
const whiteList: string[] = ['/app/hgj/partners']

export default whiteList
